export default {
    SET_1204(state, designations) {
        state.designations = designations
    },
    SET_313(state, provinces) {
        state.provinces = provinces
    },
    SET_314(state, typeOrganisation) {
        state.typeOrganisation = typeOrganisation
    },
    SET_1102(state, regionAdministrative) {
        state.regionAdministrative = regionAdministrative
    },
    SET_PARENT_7823(state, designationsContextChamps) {
        state.designationsContextChamp = designationsContextChamps
    },
    SET_PARENT_7824(state, desginationsContextExpertise) {
        state.desginationsContextExpertise = desginationsContextExpertise
    },
    SET_PARENT_7822(state, designationsContextPratique) {
        state.designationsContextPratique = designationsContextPratique
    }
}